import { useBadge } from "@/hooks/useBadge.ts";
import { useEffect } from "react";

const BASE_TITLE = "Okthx Web";

/**
 * Prefixes the browser tab title with the awareness badge count, e.g.
 * "(3) Okthx Web", so a needs-you / unseen-completed count is visible from the
 * tab even when the window isn't focused. Mount once near the app root.
 */
export const useDocumentTitleBadge = () => {
  const { badge } = useBadge();
  const awarenessCount = badge?.awarenessCount ?? 0;

  useEffect(() => {
    document.title = awarenessCount > 0 ? `(${awarenessCount}) ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [awarenessCount]);
};
